import { Component, Inject, OnInit } from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-new-version-dialog',
  imports: [
    TranslatePipe,
    MatIcon
  ],
  templateUrl: './new-version-dialog.component.html',
  styleUrl: './new-version-dialog.component.css'
})
export class NewVersionDialogComponent implements OnInit {
  message: string;

  constructor(
    public dialogRef: MatDialogRef<NewVersionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {
    this.message = data.message;
  }

  ngOnInit() {
    setTimeout(() => this.close(), 10000);
  }

  close() {
    this.dialogRef.close();
  }
}
